export interface SuperAdminPartner {
  id: string;
  name: string;
  internal_name: string;
  to_label: string;
}

export function toSuperAdminPartner(data: SuperAdminPartner) {
  return {
    id: data.id,
    name: data.name,
    internalName: data.internal_name,
    label: data.to_label,
  };
}
